import { RootState } from '@atredux/store'

export const getSeawardIFrame = (state: RootState): any => state.iframe.seawardIFrame

export const getIsSeawardFrameLoading = (state: RootState): any => state.iframe.isSeawardFrameLoading

export const getSeawardProvisionError = (state: RootState): any => state.iframe.seawardProvisionError

export const getIsSeawardModalOpen = (state: RootState): any => state.iframe.isSeawardModalOpen
